var debugEnabled = false;
var stacktracesEnabled = false;
export function enableLogger(enable) {
  debugEnabled = enable;
}
export function enableStacktraces(enable) {
  stacktracesEnabled = enable;
}
export function logStacktrace() {
  if (stacktracesEnabled) {
    // eslint-disable-next-line no-console
    console.log(new Error().stack);
  }
}
export default function debug(msg) {
  if (debugEnabled) {
    var _console;
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    // eslint-disable-next-line no-console
    (_console = console).log.apply(_console, [msg].concat(args));
  }
}